import { render, staticRenderFns } from "./Trendyol.vue?vue&type=template&id=13e6cfff&scoped=true"
import script from "./Trendyol.vue?vue&type=script&lang=js"
export * from "./Trendyol.vue?vue&type=script&lang=js"
import style0 from "./Trendyol.vue?vue&type=style&index=0&id=13e6cfff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6cfff",
  null
  
)

export default component.exports